<template>
  <div>
    <a-modal v-model="visible" title="消息接收者" :footer="null">
      <div class="list-box">
        <div class="item">
          <a-table :columns="columns" :data-source="listData" :pagination="false" :row-key="(record)=>record.userId">
          </a-table>
        </div>
      </div>
    </a-modal>
  </div>
</template>
<script>
export default {
  props: {
    listData: "",
  },
  data() {
    return {
      visible: false,
      columns: [
        {
          title: "成员编号", 
          dataIndex: "userId",

        },
        {
          title: "成员名称", 
          dataIndex: "real_name",
        },
      ],
    };
  },
  components: {
    
  },
  created() {

  },
  mounted() {},
  methods: {

  },
};
</script>
<style lang="less" scoped>
@import "~@/assets/css/base.less";
.list-box {
  height: 300px;
  overflow: auto;
  .empty-box{
    height: 300px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
/deep/ .ant-modal-body {
  padding: 0 !important;
}
</style>
<style >
</style>